import { AppBar, IconButton, ListItemIcon, Menu, MenuItem, Toolbar, Typography, useTheme } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store/store";
import { setAppConfig } from "../../store/appConfig";
import { callServerTepngUserLogout } from "../../helpers/utils";
import { useState } from "react";
import { AccountCircle, Brightness4, Brightness7, Logout } from "@mui/icons-material";
import MenuIcon from '@mui/icons-material/Menu';


interface Props {
    drawerWidth: string
    isSidebarOpen: boolean
    setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>

}
function Navbar(props: Props) {
    const dispatch = useAppDispatch();
    const appConfig = useAppSelector(state => state.appConfig.value);
    const serverGlobalSettings = useAppSelector(state => state.serverGlobalSettings.value);
    const userLoggedOn = useAppSelector(state => state.loggedOnUserProfile.value);

    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const [profileMenuAnchorEl, setProfileMenuAnchorEl] = useState<Element | null>(null);
    const logout = async () => {

        await callServerTepngUserLogout()
    }
    const theme = useTheme();


    return (
        <>
            <AppBar sx={{
                height: 50,
                position: 'static',
                background: theme.palette.background.default
            }}>
                <Toolbar >

                    <IconButton onClick={() => props.setIsSidebarOpen(!props.isSidebarOpen)}>
                        <MenuIcon />
                    </IconButton>
                    &nbsp;&nbsp;
                    <Typography variant="subtitle1" color="textPrimary" > <b>Petroleum Profit Tax Reconciliation </b> </Typography>
                    <div style={{ flexGrow: 1 }} />
                    <Typography variant="subtitle1" color="textPrimary">
                        {userLoggedOn == null ? 'No User logged in' : `Welcome ${userLoggedOn.firstName} `}
                    </Typography>
                    <IconButton color="secondary" edge="end" title={userLoggedOn?.email} onClick={(event) => { setProfileMenuAnchorEl(event.currentTarget); setShowProfileMenu(previous => !previous) }}> <AccountCircle fontSize="large" /> </IconButton> &nbsp;&nbsp;&nbsp;&nbsp;
                    <Typography variant="subtitle2" color="textPrimary" title={
                        "Client Environment: " + appConfig.ENVIRONMENT +
                        "\nServer Environment: " + serverGlobalSettings?.environment +
                        "\nClient App Version: " + appConfig.APP_VERSION +
                        "\nServer App Version: " + serverGlobalSettings?.app_version +
                        "\nClient Last Updated: " + new Date(appConfig.APP_LAST_UPDATED) +
                        "\nServer Last Updated: " + (serverGlobalSettings == null ? "" : new Date(serverGlobalSettings.app_last_updated))}>
                        {appConfig.ENVIRONMENT.toUpperCase()}   &nbsp;&nbsp;&nbsp; </Typography> &nbsp;&nbsp;

                    <IconButton onClick={() => dispatch(setAppConfig({ ...appConfig, DARK_MODE: !appConfig.DARK_MODE }))} color="secondary" title={appConfig.DARK_MODE ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
                        {appConfig.DARK_MODE ? <Brightness7 /> : <Brightness4 />}
                    </IconButton>
                    <Menu style={{ zIndex: 1400 }} anchorEl={profileMenuAnchorEl} open={showProfileMenu} onClose={() => { setShowProfileMenu(false) }}>
                        <MenuItem onClick={() => logout()}><ListItemIcon><Logout /></ListItemIcon>Logout</MenuItem>
                    </Menu>
                </Toolbar>


            </AppBar>
        </>
    )
}
export default Navbar